import { axiosClient } from "./axiosClient"

export const PRODUCTION_PLAN_PATH = '/api/v1/production-plan'

export const getAllProductionPlans = ({ recordId = "" }) => {
    return axiosClient.get(`${PRODUCTION_PLAN_PATH}/all?recordId=${recordId}`)
}

export const addProductionPlan = (body) => {
    return axiosClient.post(PRODUCTION_PLAN_PATH, body)
}

export const updateProductionPlan = (id, body) => {
    return axiosClient.put(`${PRODUCTION_PLAN_PATH}/${id}`, body)
}

export const updateProductionPlanComplete = (id, body) => {
    return axiosClient.put(`${PRODUCTION_PLAN_PATH}/complete-update/${id}`, body)
}

export const deleteProductionPlan = (id) => {
    return axiosClient.delete(`${PRODUCTION_PLAN_PATH}/${id}`)
}

export const getProductionPlanById = (id) => {
    return axiosClient.get(`${PRODUCTION_PLAN_PATH}/${id}`)
}

export const sendProductionPlanById = (id) => {
    return axiosClient.put(`${PRODUCTION_PLAN_PATH}/send/${id}`)
}

export const takeBackProductionPlanById = (id) => {
    return axiosClient.put(`${PRODUCTION_PLAN_PATH}/take-back/${id}`)
}

export const completeProductionPlanById = (id) => {
    return axiosClient.put(`${PRODUCTION_PLAN_PATH}/complete/${id}`)
}

// export const getPageCustomers = ({ lastId = '', id = "", code = '', name = '' }) => {
//     return axiosClient.get(`${CUSTOMER_PATH}/page?lastId=${lastId}&id=${id}&code=${code}&name=${name}`)
// }